import { Injectable } from '@angular/core';
import * as global_var from '../../global.variable';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  /**** Fetch initial data for dashobard start ****/
  getInitialData(data) {
    return this.http.post(global_var.apiUrl + 'getdashboardinitial', data).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  /**** Fetch initial data for dashobard end ****/

  /**** dismiss Notification ****/
  dismissNotification(data) {
    return this.http
      .post(global_var.apiUrl + 'dismissnotificationdashboard', { data })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getUpdatedNotifications(data){
    return this.http
      .post(global_var.apiUrl + 'getNotification',data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getGeoCode(data) {
    const json = {};
    json['location'] = data;
    return this.http.post(global_var.apiUrl + 'getGeoCode', json).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  /**** dismiss notification end ****/
}
